"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = exports.StyledInput = exports.Container = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          background-color: ", ";\n          border-color: ", ";\n          ", " {\n            color: ", ";\n          }\n          svg {\n            fill: ", ";\n\n            path {\n              fill: ", ";\n            }\n          }\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: 25.4vw;\n  height: 75px;\n  min-width: 300px;\n  cursor: pointer;\n\n  background: #ffffff;\n  border: 1px solid;\n  border-color: ", ";\n  border-radius: 2px;\n  font-family: ", ";\n  font-size: 1.6rem;\n  ", " {\n    color: ", ";\n  }\n  svg {\n    fill: ", ";\n  }\n  svg {\n    margin: auto 1.6vw;\n    fill: ", ";\n  }\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto 0 0.2vw;\n  font-size: 1.4rem;\n  line-height: 2rem;\n  letter-spacing: 0.1rem;\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Text = _styledComponents.default.span(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.typo.highlight;
});

exports.Text = Text;

var StyledInput = _styledComponents.default.input(_templateObject2());

exports.StyledInput = StyledInput;
StyledInput.displayName = 'StyledInput';

var Container = _styledComponents.default.label(_templateObject3(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.ui.outline;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.font;
}, Text, function (_ref4) {
  var disabled = _ref4.disabled,
      theme = _ref4.theme;
  return disabled ? theme.ui.outline : null;
}, function (_ref5) {
  var disabled = _ref5.disabled,
      theme = _ref5.theme;
  return disabled ? theme.ui.outline : null;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.ui.interactive;
}, function (_ref7) {
  var checked = _ref7.checked,
      theme = _ref7.theme;
  return checked ? (0, _styledComponents.css)(_templateObject4(), theme.brand.lightest, theme.brand.secondary, Text, theme.brand.primary, theme.brand.primary, theme.brand.primary) : null;
});

exports.Container = Container;